import YQImage from '@/renderer/components/common/YQImage';
import { useBossProcessStore } from '@/renderer/store/process';
import { WorkStatusEnum } from '@/renderer/types/enum/user';
import { ProCard } from '@ant-design/pro-components';
// import { Button } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ProcessAction = () => {
  const { onPaused, onStart, processStatus } = useBossProcessStore();

  const STATUS_TITLE_MAP = useMemo<Record<WorkStatusEnum, string>>(
    () => ({
      [WorkStatusEnum.Running]: 'Task is running......',
      [WorkStatusEnum.Stopped]: 'Task is paused......',
    }),
    [],
  );

  const STATUS_BUTTON_MAP = useMemo<Record<WorkStatusEnum, string>>(
    () => ({
      [WorkStatusEnum.Running]: 'Pause',
      [WorkStatusEnum.Stopped]: 'Start',
    }),
    [],
  );

  const { t } = useTranslation(['dashboard']);

  const [isFetching, setIsFetching] = useState(false);
  const handleProcessStatus = useCallback(async () => {
    try {
      setIsFetching(true);
      if (processStatus === WorkStatusEnum.Running) {
        await onPaused();
      } else if (processStatus === WorkStatusEnum.Stopped) {
        await onStart();
      } else {
        throw new Error('not support status');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  }, [onPaused, onStart, processStatus]);

  return (
    <ProCard title={STATUS_TITLE_MAP[processStatus]} bordered>
      <div className="mt-[1rem]">
        <div className="flex gap-2">
          <YQImage
            src="https://oss.pop.public.hothappymax.com/ai_recruitment_client_web/assets/u60.png"
            width={500}
            height={333}
          />
          <div>
            <div className="text-[0.24rem] text-gray-500">
              {t('startProcessDesc', { ns: 'dashboard' })}
            </div>

            <button
              onClick={handleProcessStatus}
              disabled={isFetching}
              type="button"
              className="mt-1 w-[1.15rem] h-[1.15rem] border-solid border-white border-[1px] rounded-full bg-blue-500 flex items-center justify-center font-bold text-[0.36rem] text-white cursor-pointer shadow-lg shadow-slate-700 shadow-offset-x-2 shadow-offset-y-0"
            >
              {STATUS_BUTTON_MAP[processStatus]}
            </button>
          </div>
        </div>

        {/* <div className="flex flex-col items-center gap-1">
            {processStatus === 'running' && (
              <Button
                type="primary"
                style={{ width: '2rem', height: '0.35rem' }}
                onClick={onPaused}
              >
                Pause
              </Button>
            )}
            {processStatus === WorkStatusEnum.Paused && (
              <Button
                type="primary"
                style={{ width: '2rem', height: '0.35rem' }}
                onClick={onStart}
              >
                continue
              </Button>
            )}
            <Button
              style={{ width: '2rem', height: '0.35rem' }}
              onClick={onRestart}
            >
              Terminate
            </Button>
          </div> */}

        {/* <div>当前状态：{processStatus}</div>
      <Button onClick={onStart}>启动</Button>
      <Button onClick={onPaused}>暂停</Button>
      <Button onClick={onRestart}>重启</Button> */}
      </div>
    </ProCard>
  );
};

export default ProcessAction;
